<template>
  <div class="form">
    <!-- Pre 20230802
    <h3>FÅ STILLET DINE PAKKER, NÅR DU IKKE ER HJEMME</h3>
    <p>Med et fuldmagtsskilt fra GLS slipper du for at sidde klar derhjemme, når du venter en pakke.</p>
    <p>Når du har bestilt og modtaget et skilt, stiller vi dine pakker på det ønskede sted. Du vælger selv og beskriver et sted på din adresse ved tilmeldingen nedenfor.</p>
    <p>Fuldmagten gælder for hele husstanden.</p>
    <p>Vær opmærksom på, at denne leveringstype desværre ikke egner sig til etageejendomme, og at GLS ikke har adgang til opgange med dørtelefon.</p>
    <br> -->

    <!-- Updated 20230802 -->
    <h3>FÅ STILLET DINE PAKKER, NÅR DU IKKE ER HJEMME</h3>
    <p>Med et fuldmagtsskilt fra GLS slipper du for at sidde klar, hvis du venter en pakke til hjemmelevering.</p>
    <p>Når du har bestilt og modtaget et skilt, stiller vi dine pakker på det ønskede sted. Du vælger selv stedet på din adresse og beskriver det i tilmeldingen nedenfor (husk at placere fuldmagtsskiltet på det ønskede sted).</p>
    <p>Fuldmagten gælder for hele husstanden, og når du først har et fuldmagtsskilt, skal du ikke bestille det igen, med mindre du ønsker at ændre stedet, hvor vi må stille dine pakker.</p>
    <p>Vær opmærksom på, at denne leveringstype desværre ikke egner sig til etageejendomme, og at GLS ikke har adgang til opgange med dørtelefon.</p>
    <br>

      <FormGroup>
      <TextInput
        v-model="$v.address.firstname.$model"
        label="Fornavn"
        :max="50"
        required
        :error="$v.address.firstname.$error"
        error-message="Udfyld fornavn"
        id="Fornavn"
      />

      <TextInput
        v-model="$v.address.lastname.$model"
        label="Efternavn"
        :max="50"
        :error="$v.address.lastname.$error"
        :errorMessage="
          !$v.address.lastname.required ? 'Udfyld efternavn' : ''
        "
        required
        id="Lastname"
      />
    </FormGroup>
      <FormGroup>
      <TextInput
        v-model="$v.address.mail.$model"
        label="Mail"
        required
        :error="emailErrorValidation"
        :max="50"
        v-on:leave="emailInputLeave"
        :errorMessage="
          !$v.address.mail.required
            ? 'Udfyld mail'
            : !$v.address.mail.email
            ? 'Indtast gyldig mail'
            : ''

        "
        id="mail"

      />
      <TextInput
        v-model="$v.address.phone.$model"
        label="Mobil"
        :error="phoneErrorValidation"
        v-on:leave="phoneInputLeave"
        :errorMessage="
          !$v.address.phone.required
            ? 'Udfyld mobilnummer'
            : !$v.address.phone.isNumber
            ? 'Indtast venligst gyldigt mobilnummer (8 tal)'
            : ''
        "
        required
        id="phone"

      />
    </FormGroup>
      <FormGroup style="margin-bottom: 3px; margin-top:2px">
      <CheckboxInput
        label="Virksomhed"
        v-model="address.company"
        id="company"
      />
    </FormGroup>
      <template v-if="address.company">
      <FormGroup >
        <TextInput
          v-model="$v.address.companyname.$model"
          label="Firmanavn"
          :max="50"
          required
          :error="$v.address.companyname.$error"
          :errorMessage="
            !$v.address.companyname.required ? 'virksomhedens navn' : 'nej'
          "
          id="companyname"
        />
      </FormGroup>
      <FormGroup style="margin-bottom: 1px;">
        <TextInput
          v-model="$v.address.contactFirstname.$model"
          label="Kontaktperson Fornavn"
          :max="50"
          :error="$v.address.contactFirstname.$error"
          :errorMessage="
            !$v.address.contactFirstname.required
              ? 'Udfyld kontaktpersonens fornavn'
              : ''
          "

          required
          id="contactFirstname"
        />
        <TextInput
          v-model="$v.address.contactLastname.$model"
          :max="50"
          :error="$v.address.contactLastname.$error"
          :errorMessage="
            !$v.address.contactLastname.required
              ? 'Udfyld kontaktpersonens efternavn'
              : ''
          "
          label="Efternavn"
          required
          id="contactLastname"
        />
      </FormGroup>
    </template>
      <AddressAutoComplete
              :filterby="'tekst'"
              @selected="addressSelected($event)"
              v-on:dawa="setAddress"
              v-on:check="addressInputLeave"
              :error="addressError"
              errorMessage="Udfyld adresse"
      />
    <small
            style="color:grey;display: block; margin-top: 4px"
      >Hvor må vi stille pakken? Fuldmagten skal hænges det nævnte sted: *</small
    >
    <FormGroup class="column">
      <SelectInput
        :items="options"
        required
        id="location"
        v-model="$v.address.location.$model"
        itemText="text"
        itemValue="id"
        :error="$v.address.location.$error"
        :errorMessage="!$v.address.location.required ? 'Vælg lokation' : ''"
        small
        full-width
        class="select"
      />
      <TextInput
        v-model="$v.address.extra.$model"
        id="extra"
        required
        :max="50"
        mobilelabel="Tilføj yderlig beskrivelse"
        :error="$v.address.extra.$error"
        :errorMessage="
          !$v.address.extra.required && $v.address.location.$model !== null
            ? `Tilføj yderlig beskrivelse`
            : ''
        "

        fullWidth
        class="input"
        placeholder="Eks. I hjørnet ved den lille værktøjskasse"
      />
    </FormGroup>

      <CheckboxInput
        label="Ja tak, jeg vil gerne adviseres, når GLS leverer pakker."
        v-model="address.acceptSmsAdvise"
        id="acceptsmsadvice"
        style="margin-bottom: 7px;"
      />

      <CheckboxInput
              label="Ja, jeg accepterer <a  href='../betingelser.pdf' target='_blank'>betingelserne</a>"
              v-model="$v.address.acceptConditions.$model"
              @change="$v.acceptConditions.$touch()"
              :error="$v.address.acceptConditions.$error"
              errorMessage="Betingelserne skal accepteres"
              style="margin-bottom: 9px;"
      />



    <FormGroup>
      <Button   @click="submit"
              :disabled="submitting"
                class="blue"
      >

      <span v-if="!submitting">Bestil</span>
        <span v-else>Sender...</span>
      </Button
      >
    </FormGroup>

  </div>

</template>

<script>
  // import DawaAutoComplete from "@/components/DawaAutoComplete.vue"
  import AddressAutoComplete from "@/components/inputs/AddressAutoComplete.vue"
import TextInput from "@/components/TextInput.vue";
import SelectInput from "@/components/SelectInput.vue";
import CheckboxInput from "@/components/CheckboxInput.vue";
import FormGroup from "@/components/FormGroup.vue";
import Button from "@/components/Button.vue";
//import {isChecked} from "../validators";
import {
  required,
  requiredIf,
  numeric,
  email,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
import { SignerService } from "../services/SignerService";

export default {
  components: {
    TextInput,
    SelectInput,
    CheckboxInput,
    FormGroup,
    Button,
    // DawaAutoComplete
    AddressAutoComplete
  },
  props: ["address"],
  data() {
    return {
      submitting:false,
      addressError: false,
      emailErrorValidation:false,
      phoneErrorValidation:false,
      options: [
        { id: 1, text: "I garagen/carporten" },
        { id: 2, text: "På terrassen" },
        { id: 3, text: "Ved bagdøren" },
        { id: 4, text: "I skuret/værkstedet" },
        { id: 5, text: "I legehuset" },
        { id: 6, text: "Under halvtaget" },
        { id: 7, text: "I bryggerset/entreen" },
        { id: 8, text: "I pakkepostkassen" },
        { id: 9, text: "I drivhuset" },
        { id: 10, text: "Andet" }
      ],
      company: false,
    };

  },
  created() {
    this.$v.address.location.$model = 1;
  },
  methods: {
    addressSelected(item) {      
        if(item != null)
          this.addressError = false;
        this.address.address = item.vejnavn;
        this.address.houseno = item.husnr;
        this.address.floor=item.etage;
        this.address.door=item.dør;
        this.address.zipcode = item.postnr;
        this.address.city = item.postnrnavn;
        this.address.adresseid=item.id;
    },
    setAddress(e){
      this.$v.address.addressFilled.$model=e;
    },
    addressInputLeave(){
      this.$v.address.addressFilled.$touch();

      if(this.$v.address.addressFilled.$error){
        this.addressError = true;
      }
      else{
        this.addressError = false;
      }
      if(this.$v.address.zipcode.$model.length !== 4){
        this.addressError = true;
      }
    },
    emailInputLeave(){
      this.$v.address.mail.$touch();

      if(this.$v.address.mail.$error){
        this.emailErrorValidation = true;
      }
      else{
        this.emailErrorValidation = false;
      }
    },
    phoneInputLeave(){
      this.$v.address.phone.$touch();

      if(this.$v.address.phone.$error){
        this.phoneErrorValidation = true;
      }
      else{
        this.phoneErrorValidation = false;
      }
    },
    async submit() {
      this.$v.$touch();
      this.emailInputLeave();
      this.phoneInputLeave();
      this.addressInputLeave();      
      if (!this.$v.$invalid) {
        // if (!this.addressError) {      
        this.submitting=true;
        this.$emit('submitting',true);
        const signUrl = await SignerService.getsignerUrl({
          firstname: this.$v.address.firstname.$model,
          lastname: this.$v.address.lastname.$model,
          mail: this.$v.address.mail.$model,
          phone: this.$v.address.phone.$model,
          address: this.$v.address.address.$model,
          zipcode: this.$v.address.zipcode.$model,
          city: this.$v.address.city.$model,
          location:this.options.filter(x=>x.id==this.$v.address.location.$model)[0].text,
          extra: this.$v.address.extra.$model,
          houseno:this.$v.address.houseno.$model,
          floor:this.$v.address.floor.$model,
          door:this.$v.address.door.$model,
          smsadvice:this.address.acceptSmsAdvise,
          companyname: this.address.company ? this.$v.address.companyname.$model : "",
          contactFirstname: this.address.company ? this.$v.address.contactFirstname.$model : "",
          contactLastname: this.address.company ? this.$v.address.contactLastname.$model : "",
          adresseid: this.$v.address.adresseid.$model
        });

        if (signUrl.status===200 )
           window.location.href = signUrl.data;
        else  alert('Der er desværre sket en fejl!');
      }

    }
  },
  validations: {
    address: {
      firstname: {
        required
      },
      lastname: {
        required
      },
      companyname: {
        required: requiredIf(function(nestedModel) {
          return nestedModel.company;
        })
      },
      contactFirstname: {
        required: requiredIf(function(nestedModel) {
          return nestedModel.company;
        })
      },
      contactLastname: {
        required: requiredIf(function(nestedModel) {
          return nestedModel.company;
        })
      },
      address: {
        required
      },
      zipcode: {
        required,
        numeric,
        minLength: minLength(4),
        maxLength: maxLength(4)
      },
      city: {
        required
      },
      mail: {
        required,
        email
      },
      phone: {
        required,
        numeric,
        minLength: minLength(8),
        maxLength: maxLength(8)
      },
      location: {
      },
      extra: {
        required,
        maxLength: maxLength(50)
      },
      acceptConditions: {
        checked (val) {
          return val
        }
      },
      houseno:{

      },
      adresseid:
              {

              },
      floor:{

      },
      door:{

      },
      addressFilled:{
        minLength: minLength(3),
        required
      }


    }
  }
};
</script>
<style lang="scss" scoped>

  .main {
    max-width: 1020px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    #location,
    #extra{
      width:100%;
      margin:0 5px;
    }
    @media screen and (max-width: 800px) {
      flex-direction: column-reverse;
    }
    @media screen and (max-width:800px ){
    .column{
        flex-direction: column;
      }
    }
    .labelText{
      font-family: "Newson", Verdana, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
    }
    .orderButton
    {

      width: 140px;
      background: #FFD100;
      border-radius: 45px;
      margin-left:auto;
    }
    .logo {
      max-width: 200px;
      display: flex;
      flex-direction: column;
      @media screen and (max-width: 800px){
        flex-direction: row;
      }
      button{
        align-self: center;
        margin-top:auto;


      }

      img {
        width: 100%;
      }
      @media screen and (max-width: 1080px) {
        max-width: calc(600 / 19.2) * 1vw;
      }
      @media screen and (max-width: 800px) {
        display: flex;
        justify-content: center;
        width: 100%;
        max-width: 100%;
        img {
          width: 50%;
        }
      }
    }
  }

</style>